import 'styles/privacyPolicy.scss'
import {Urls} from '../constants'


(function () {
    /* global $ */
    "use strict";

    
    var Attributes = {
        init: function () {
            this.adjustDom();
            this.bindUIActions();
            this.unload();
        },

        adjustDom: function () {
           
        },

        bindUIActions: function () {

        },

        unload: function () {},
    };

    Attributes.init();
})();